import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Link from 'next/link';
import Image from 'next/image';
import Logo from '@/public/logo.svg';
import Container from './Container';

const SimpleHeader = () => {
  const hrefSell = '/sell';
  return (
    <Navbar expand="lg" className="border-bottom p-0">
      <Container>
        <Navbar.Brand className="spiritoryLogo" as={Link} href="/">
          <Image src={Logo} alt="Spiritory Logo" />
        </Navbar.Brand>
        <Nav className="ms-auto" as={Link} href={'/sell'}>
          <Nav.Link as="span" className="flex-fill text-dark">
            FAQ
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default SimpleHeader;
